import { useQuery } from "@tanstack/react-query";
import { type Address } from "viem";

import { LOOPER_AJNA_ABI } from "@/config/looper-abi";
import { VENUES } from "@/config/contracts";
import { buildPublicClient } from "@/lib/wallet/clients";

export const ajnaPositionAddressQueryKey = (account: Address, looper: Address) =>
  ["ajna-position-address", account, looper] as const;

export const fetchAjnaPositionAddress = async (account: Address, looper: Address): Promise<Address> => {
  const client = buildPublicClient();
  return await client.readContract({
    address: looper,
    abi: LOOPER_AJNA_ABI,
    functionName: "positionOf",
    args: [account],
  }) as Address;
};

export const useAjnaPositionAddress = (account: Address | undefined) =>
  useQuery({
    queryKey: ajnaPositionAddressQueryKey(account as Address, VENUES.ajna.looper),
    enabled: Boolean(account),
    queryFn: () => fetchAjnaPositionAddress(account as Address, VENUES.ajna.looper),
  });
